import { useId, type PropsWithChildren, type ReactNode } from 'react'

import { Heading } from '@/src/domains/design-system/components/Heading'

export interface SelfAssessmentWizardCardProps extends PropsWithChildren {
  heading: ReactNode
  autoFocus: boolean
}

const focusHeading = (element: HTMLHeadingElement | null) => element?.focus()

export const SelfAssessmentWizardCard = ({ heading, autoFocus, children }: SelfAssessmentWizardCardProps) => {
  const headingId = useId()

  return (
    <section
      aria-labelledby={headingId}
      className="flex min-h-[37.5rem] flex-col gap-8 rounded-3xl bg-white-500 p-6 tablet:p-12"
    >
      <Heading asChild variant="2xl" className="text-petrol-500">
        <h2 id={headingId} tabIndex={-1} ref={autoFocus ? focusHeading : undefined}>
          {heading}
        </h2>
      </Heading>

      {children}
    </section>
  )
}
